import { type FunctionComponent, type ReactNode, type SVGProps } from 'react';
import classNames from 'classnames';
import styles from './EmptyState.module.scss';

export interface EmptyStateFeature {
  key: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  title: ReactNode;
  desc: ReactNode;
}

interface EmptyStateProps {
  illustration: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  cta?: ReactNode;
  features?: EmptyStateFeature[];
  className?: string;
}

const EmptyState = ({
  illustration,
  title,
  subtitle,
  cta,
  features,
  className,
}: EmptyStateProps) => (
  <div className={classNames(styles.card, className)}>
    <div className={styles.illustration} aria-hidden="true">
      {illustration}
    </div>
    <h2 className={styles.title}>{title}</h2>
    {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    {cta && <div className={styles.cta}>{cta}</div>}
    {features && features.length > 0 && (
      <>
        <div className={styles.divider} />
        <ul className={styles.features}>
          {features.map(({ key, icon: Icon, title: t, desc }) => (
            <li key={key} className={styles.feature}>
              <div className={styles.featureIcon} aria-hidden="true">
                <Icon />
              </div>
              <div className={styles.featureText}>
                <div className={styles.featureTitle}>{t}</div>
                <div className={styles.featureDesc}>{desc}</div>
              </div>
            </li>
          ))}
        </ul>
      </>
    )}
  </div>
);

export default EmptyState;
